export type ColorTheme = "dark" | "light";

export function readColorTheme(): ColorTheme {
  return window.localStorage.getItem("theme") === "light" ? "light" : "dark";
}

export function applyColorTheme(theme: ColorTheme) {
  document.documentElement.dataset.theme = theme;
  window.localStorage.setItem("theme", theme);
}

export function initializeColorTheme() {
  applyColorTheme(readColorTheme());
}
